// extracted by mini-css-extract-plugin
module.exports = {"disclosureContainer":"styles_disclosureContainer__mUnU1","disclosure":"styles_disclosure__+DuwH","disclosureContent":"styles_disclosureContent__bieou"};